//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import logo from "../../assets/icon.png";
import arrow from "../../assets/arrow.png";
import DropdownMenu from './DropDownMenu';
import MobileHeader from './MobileMenu';
import VoiceFirstChatInterface from '../MobileChatInterface'; 
import { Mic } from 'lucide-react';
import { MessageCircle } from 'lucide-react';

const Header: React.FC = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [activeMenu, setActiveMenu] = useState("");
    const [isChatOpen, setIsChatOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleChangeMenu = (menu: string) => {
        setActiveMenu(activeMenu === menu ? "" : menu);
    };

    const toggleChat = (e) => {
        e.preventDefault();
        setIsChatOpen(!isChatOpen);
        if (activeMenu !== "") {
            setActiveMenu("");
        }
    };

    if (isMobile) {
        return (
            <>
                <MobileHeader />
                <VoiceFirstChatInterface isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
            </>
        );
    }

    return (
        <>
            <div className="fixed w-full z-[99] top-4 left-1/2 -translate-x-1/2 flex flex-wrap justify-center">
                <div className="inline-block relative">
                    <div className="flex items-center justify-start w-auto p-1 rounded-[16px] bg-black gap-3 shadow-lg">
                        <div className="relative flex items-center justify-center">
                           
                            <div className="absolute w-11 h-11 rounded-[10px] border border-white opacity-40 animate-ping"></div>
                            
                            {/* Inner pulse ring with lighter opacity */}
                            <div className="absolute w-11 h-11 rounded-[10px] border border-white opacity-20 animate-pulse"></div>

                            {/* Subtle white glow behind the logo */}
                            <div className="absolute w-10 h-10 rounded-[10px] bg-white bg-opacity-10 blur-sm"></div>

                            {/* Actual logo */}
                            <Link
                                to="/"
                                className="relative z-10 transition-transform duration-300 hover:scale-105"
                                onClick={toggleChat}
                                aria-label="Open chat"
                                >
                                <div className="relative">
                                    {/* Logo */}
                                    <img
                                    src={logo}
                                    alt="Logo"
                                    width={40}
                                    height={40}
                                    className="rounded-[10px]"
                                    />
                                    
                                    {/* Chat Bubble Icon */}
                                    <div className="absolute top-[-8px] right-[-12px] p-2">
                                        <Mic size={16} color="#ffffff" />
                                    </div>
                                </div>
                                </Link>

                        </div>

                        {/* Menu items */}
                        <div
                            className="flex items-center gap-2 relative cursor-pointer"
                            onClick={() => handleChangeMenu("company")}
                        >
                            <p className="text__14 text-white">Company</p>
                            <img
                                src="/images/Arrow Down.svg"
                                className={`transition-all duration-300 ${
                                    activeMenu === "company" ? "-rotate-180" : "rotate-0"
                                }`}
                                alt=""
                            />
                        </div>
                        <div
                            className="flex items-center gap-2 relative cursor-pointer"
                            onClick={() => handleChangeMenu("products")}
                        >
                            <p className="text__14 text-white">Products</p>
                            <img
                                src="/images/Arrow Down.svg"
                                className={`transition-all duration-300 ${
                                    activeMenu === "products" ? "-rotate-180" : "rotate-0"
                                }`}
                                alt=""
                            />
                        </div>
                        <div
                            className="flex items-center gap-2 relative cursor-pointer"
                            onClick={() => (window.location.href = 'https://app.futeur.ai/signup')}
                        >
                            <p className="text__14 text-white">Signup</p>
                        </div>

                        <button
                            onClick={() => (window.location.href = 'https://app.futeur.ai/signin')}
                            className="inline-block font-medium text__14 px-4 py-2 bg-white text-Mbaseblack rounded-[12px]"
                        >
                            Login
                        </button>
                    </div>
                </div>

                <DropdownMenu active={activeMenu} menu="company" />
                <DropdownMenu active={activeMenu} menu="products" />
            </div>

            <div
                onClick={() => setActiveMenu("")}
                className={`fixed w-full h-full left-0 top-0 z-[70] transition-all duration-300 ${
                    activeMenu !== "" ? "bg-black opacity-60" : "opacity-0 pointer-events-none"
                }`}
            ></div>
            
            {/* Chat Interface */}
            <VoiceFirstChatInterface isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
        </>
    );
};

export default Header;
